import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';

import style from './index.module.scss';
import { Button } from '@/components';
import { useGroupProposalCreate } from '@/views/GroupProposal/hooks/create';
type ModalProps = {
  hide(): void;
  groupId: number;
  id: number;
};

export const PinPostToGroupModal = ({ hide, id, groupId }: ModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync, isLoading } = useGroupProposalCreate(groupId);

  const onConfirm = useCallback(() => {
    mutateAsync({
      type: 'pin_article',
      data: {
        article_id: id,
      },
    }).then(res => {
      if (res.proposal) {
        hide();
      }
    });
  }, [hide, id, mutateAsync]);
  return (
    <div className={style.pinToGroupModal}>
      <div className={style.header}>{t('GroupModalManager_PinPostToGroupModal.5b4r0g')}</div>
      <div className={style.subDesc}>
        {t('GroupModalManager_PinPostToGroupModal.4rllyi')}
        <br />
        <br />
        {t('GroupModalManager_PinPostToGroupModal.ix144r')}
      </div>

      <div className={style.buttons}>
        <Button type="default" className={style.button} onClick={hide}>
          {t('GroupModalManager_PinPostToGroupModal.x9d2fu')}
        </Button>
        <Button type="primary" className={style.button} onClick={onConfirm} loading={isLoading}>
          {t('GroupModalManager_PinPostToGroupModal.mf1qqm')}
        </Button>
      </div>
    </div>
  );
};
